import { render, staticRenderFns } from "./CaseCustomFields.vue?vue&type=template&id=55e7c599&"
import script from "./CaseCustomFields.vue?vue&type=script&lang=js&"
export * from "./CaseCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports